import {createSelector} from 'reselect';

export function toJSSelector(selector) {
    return createSelector([
        selector,
    ],
    (data) => data && data.toJS());
}
